export const name = "core-single-line";

export const handleReturn = ({ multiline }) => !multiline && "handled";
